module.exports = __webpack_public_path__ + "static/media/222HO.ab9b1988.jpg";